import styled, { DefaultTheme } from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

import { ArticlesRefreshStatus } from './ArticlesSection.types';

export const ArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CountBadge = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 28px;
  height: 22px;
  border-radius: 40%;
  padding: 0 6px;
  background-color: ${({ theme }) => theme.colors.active};
  color: ${({ theme }) => theme.colors.modalBackground};
  ${getVariant({ variant: 'caption-bold' })}
`;

export const CountDelta = styled.span<{ $delta: number }>`
  ${getVariant({ variant: 'caption-bold' })}
  color: ${({ $delta, theme }) =>
    $delta > 0 ? theme.colors.reliability.high : theme.colors.secondaryText};
`;

export const HeaderMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const getStatusColor = (status: ArticlesRefreshStatus, colors: DefaultTheme['colors']) => {
  switch (status) {
    case 'loading':
      return colors.active;
    case 'success':
      return colors.reliability.high;
    case 'failure':
      return colors.warning;
    default:
      return colors.secondaryText;
  }
};

export const RefreshStatusText = styled.span<{ $status: ArticlesRefreshStatus }>`
  ${getVariant({ variant: 'caption-normal' })}
  color: ${({ $status, theme }) => getStatusColor($status, theme.colors)};
`;

export const RefreshButton = styled.button<{ $success?: boolean }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 28px;
  margin: 0;
  border: none;
  border-radius: 15%;
  padding: 0;
  background: ${({ theme }) => theme.colors.background.medium};
  color: ${({ $success, theme }) =>
    $success ? theme.colors.reliability.high : theme.colors.secondaryText};
  transition:
    border-color 150ms ease,
    color 150ms ease;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    border-color: ${({ $success, theme }) =>
      $success ? theme.colors.border : theme.colors.active};
    color: ${({ $success, theme }) =>
      $success ? theme.colors.reliability.high : theme.colors.active};
  }
`;

export const ArticlesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
